<script setup lang="ts">
const { setSeoMeta, getBreadcrumbSchema } = useSeo()

setSeoMeta({
  title: 'Fiscale Attesten - Belastingattesten Kinderopvang',
  description: 'Informatie over fiscale attesten voor kinderopvang bij \'t SpeelFabrik. Ontdek hoe je belastingvoordeel kunt krijgen voor kinderkampen en activiteiten.',
  image: '/images/og-default.jpg',
  keywords: ['fiscale attesten', 'belastingattesten kinderopvang', 'kinderopvang belasting', 'belastingvoordeel kampen'],
})

// Branded OG image
defineOgImage('SpeelFabrik', {
  title: 'Fiscale Attesten',
  description: 'Belastingattesten voor kinderopvang bij \'t SpeelFabrik.',
})

useSchemaOrg([
  getBreadcrumbSchema([
    { name: 'Home', path: '/' },
    { name: 'Fiscale Attesten', path: '/fiscale-attesten' },
  ]),
])

definePageMeta({
  layout: 'front-page',
  public: true,
  pageTitle: {
    title: 'Fiscale Attesten',
    subtitle: 'Informatie over belastingattesten voor kinderopvang',
    icon: 'bx-file',
    iconColor: 'primary',
  },
})
</script>

<template>
  <VContainer>
    <VRow>
      <VCol cols="12">
        <VCard>
          <VCardText class="text-center pa-8">
            <VIcon
              icon="bx-file"
              size="64"
              color="secondary"
              class="mb-4"
            />
            <h2 class="text-h4 mb-4">
              Fiscale Attesten
            </h2>
            <p class="text-body-1 text-medium-emphasis">
              Deze pagina is momenteel in ontwikkeling.
            </p>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>
